/* eslint-disable no-duplicate-imports */
import { SalesOrder } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import queryString from 'query-string';
import Msdyn365 from '@msdyn365-commerce/core';
import { IRequestContext, ITelemetry } from '@msdyn365-commerce/core';

export type PepperjamConfig = {
    programId: string;
    integrationType: string;
};

type PepperjamPixelProps = {
    order: SalesOrder;
    config: PepperjamConfig;
    request: IRequestContext;
    telemetry: ITelemetry;
};

const PEPPERJAM_URI = 'https://t.pepperjamnetwork.com/track';

const PepperjamPixel = ({ order, config, request }: PepperjamPixelProps) => {
    const { integrationType, programId } = config;
    const divRef = React.useRef<HTMLDivElement>(null);
    const [initialized, setInitialized] = React.useState(false);

    React.useEffect(() => {
        const div = divRef.current;

        if (initialized || !Msdyn365.isBrowser || !div) {
            return;
        }

        const refId = order.ChannelReferenceId;

        if (!refId || !integrationType || !programId || !order.SalesLines) {
            return;
        }

        const params = {
            INT: config.integrationType,
            PROGRAM_ID: config.programId,
            ORDER_ID: refId
        };

        const promoCodes = [];

        let itemOrd = 0;
        for (let i = 0; i < order.SalesLines.length; ++i) {
            const line = order.SalesLines[i];
            if (line.ItemId && line.Quantity && line.Quantity > 0) {
                itemOrd++;
                const price = (line.Price || line.OriginalPrice || line.NetAmount || 0) - (line.DiscountAmount || 0);
                params[`ITEM_ID${itemOrd}`] = line.ItemId;
                params[`ITEM_PRICE${itemOrd}`] = price;
                params[`QUANTITY${itemOrd}`] = `${line.Quantity || 0}`;
            }

            if (line.DiscountLines) {
                for (const discountLine of line.DiscountLines) {
                    if (discountLine.DiscountCode) {
                        promoCodes.push(discountLine.DiscountCode);
                    }
                }
            }
        }

        if (promoCodes.length > 0) {
            params['COUPON'] = promoCodes.join(',');
        }

        if (!itemOrd || !params) {
            return;
        }

        setInitialized(true);

        const iframeSrc = `${PEPPERJAM_URI}?${queryString.stringify(params)}`;

        const iframe = document.createElement('iframe');
        iframe.id = 'pjn-pixel';
        iframe.src = iframeSrc;
        iframe.width = '1';
        iframe.height = '1';
        iframe.frameBorder = '0';

        iframe.sandbox.add('allow-scripts');
        iframe.sandbox.add('allow-same-origin');

        div.appendChild(iframe);
    }, [initialized, divRef]);

    return <div ref={divRef} />;
};

export { PepperjamPixel };
